export default {
  terms: {
    badge: "CONDITIONS D'UTILISATION",
    title: "Conditions générales d'utilisation",
    updated: 'Dernière mise à jour : septembre 2026',
    sections: [
      {
        title: '1. Objet',
        blocks: [
          { type: 'p', text: "Les présentes Conditions générales d'utilisation régissent l'accès et l'utilisation du site internet de Limpia Sàrl." },
          { type: 'p', text: 'En accédant à ce site, l\'utilisateur reconnaît avoir pris connaissance des présentes conditions et les accepter.' },
          { type: 'p', text: 'Le site a pour objectif de présenter les activités, les prestations et les services proposés par Limpia Sàrl, ainsi que de permettre aux visiteurs de prendre contact avec l\'entreprise.' },
        ],
      },
      {
        title: '2. Informations présentées sur le site',
        blocks: [
          { type: 'p', text: 'Limpia Sàrl s\'efforce de fournir des informations exactes, actuelles et complètes sur ses services.' },
          { type: 'p', text: 'Toutefois, les informations publiées sur le site sont fournies à titre informatif et peuvent être modifiées à tout moment sans préavis.' },
          { type: 'p', text: 'Limpia Sàrl ne garantit pas que toutes les informations disponibles sur le site soient constamment exemptes d\'erreurs, complètes ou à jour.' },
        ],
      },
      {
        title: "3. Demandes de contact et demandes d'offre",
        blocks: [
          { type: 'p', text: 'Les formulaires ou coordonnées disponibles sur le site permettent aux utilisateurs de contacter Limpia Sàrl ou de demander des informations concernant ses prestations.' },
          { type: 'p', text: 'L\'envoi d\'une demande via le site ne constitue pas automatiquement une conclusion de contrat.' },
          { type: 'p', text: 'Toute prestation de services fait l\'objet d\'un accord entre Limpia Sàrl et le client et, lorsque cela est applicable, d\'une offre ou d\'un devis accepté par le client.' },
          { type: 'p', text: 'Les informations fournies par l\'utilisateur doivent être exactes et complètes afin de permettre à Limpia Sàrl de traiter correctement sa demande.' },
        ],
      },
      {
        title: '4. Propriété intellectuelle',
        blocks: [
          { type: 'p', text: 'Sauf indication contraire, l\'ensemble des contenus présents sur ce site, notamment les textes, logos, photographies, graphiques, éléments visuels, designs et autres contenus, sont protégés par les dispositions applicables en matière de propriété intellectuelle.' },
          { type: 'p', text: 'Toute reproduction, modification, distribution, publication ou utilisation commerciale du contenu du site sans l\'autorisation préalable de Limpia Sàrl est interdite, dans la mesure où cette utilisation n\'est pas autorisée par la loi.' },
        ],
      },
      {
        title: '5. Utilisation du site',
        blocks: [
          { type: 'p', text: 'L\'utilisateur s\'engage à utiliser le site de manière légale et conforme aux présentes conditions.' },
          { type: 'p', text: 'Il est notamment interdit :' },
          { type: 'li', text: 'd\'utiliser le site à des fins illégales ;' },
          { type: 'li', text: 'de tenter d\'accéder de manière non autorisée aux systèmes ou serveurs du site ;' },
          { type: 'li', text: 'de transmettre des contenus malveillants ou susceptibles d\'endommager le site ;' },
          { type: 'li', text: 'd\'utiliser les informations du site d\'une manière susceptible de porter atteinte aux droits de Limpia Sàrl ou de tiers.' },
        ],
      },
      {
        title: '6. Disponibilité du site',
        blocks: [
          { type: 'p', text: 'Limpia Sàrl s\'efforce de maintenir son site internet accessible et fonctionnel.' },
          { type: 'p', text: 'Toutefois, l\'accès au site peut être temporairement interrompu notamment pour des raisons de maintenance, de mise à jour, de problèmes techniques ou de circonstances indépendantes de la volonté de Limpia Sàrl.' },
          { type: 'p', text: 'Limpia Sàrl ne garantit pas une disponibilité permanente ou sans interruption du site.' },
        ],
      },
      {
        title: '7. Liens vers des sites tiers',
        blocks: [
          { type: 'p', text: 'Le site peut contenir des liens vers des sites internet ou services exploités par des tiers.' },
          { type: 'p', text: 'Ces liens sont fournis uniquement à titre pratique ou informatif.' },
          { type: 'p', text: 'Limpia Sàrl n\'exerce aucun contrôle sur le contenu, la disponibilité ou les pratiques de confidentialité de ces sites tiers et décline toute responsabilité à leur égard.' },
        ],
      },
      {
        title: '8. Limitation de responsabilité',
        blocks: [
          { type: 'p', text: 'Dans les limites autorisées par la législation suisse applicable, Limpia Sàrl décline toute responsabilité pour les dommages directs ou indirects pouvant résulter de l\'utilisation ou de l\'impossibilité d\'utiliser le site internet.' },
          { type: 'p', text: 'Limpia Sàrl ne peut notamment être tenue responsable des dommages résultant de problèmes techniques, d\'interruptions du service, de logiciels malveillants, de pertes de données ou d\'un accès non autorisé par des tiers, sauf disposition légale impérative contraire.' },
          { type: 'p', text: 'Les informations publiées sur le site ne constituent pas un engagement contractuel concernant une prestation particulière, sauf accord exprès contraire.' },
        ],
      },
      {
        title: '9. Protection des données',
        blocks: [
          { type: 'p', text: 'Le traitement des données personnelles effectué dans le cadre de l\'utilisation du site est régi par notre Politique de confidentialité.' },
          { type: 'p', text: 'Les utilisateurs sont invités à consulter cette politique afin de connaître les modalités de collecte, d\'utilisation, de conservation et de protection de leurs données personnelles.' },
        ],
      },
      {
        title: '10. Modifications des conditions',
        blocks: [
          { type: 'p', text: 'Limpia Sàrl se réserve le droit de modifier les présentes Conditions générales d\'utilisation à tout moment.' },
          { type: 'p', text: 'La version publiée sur le site au moment de la consultation est applicable.' },
        ],
      },
      {
        title: '11. Droit applicable',
        blocks: [
          { type: 'p', text: 'Les présentes Conditions générales d\'utilisation sont soumises au droit suisse, sous réserve des dispositions légales impératives applicables.' },
        ],
      },
      {
        title: '12. For juridique',
        blocks: [
          { type: 'p', text: 'Sous réserve des règles impératives de compétence prévues par la loi, les tribunaux compétents au siège de Limpia Sàrl sont compétents pour tout litige relatif à l\'utilisation du site internet.' },
        ],
      },
      {
        title: '13. Contact',
        blocks: [
          { type: 'p', text: 'Pour toute question concernant les présentes Conditions générales d\'utilisation, vous pouvez contacter :' },
          { type: 'p', text: 'Limpia Sàrl — Rte de Rosé 51, 1754 Avry-sur-Matran, Suisse' },
          { type: 'p', text: 'E-mail : info@limpiasarl.ch' },
          { type: 'p', text: 'Téléphone : +41 26 436 10 83 & +41 79 887 72 52' },
        ],
      },
    ],
  },
};